var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"carousel"},[_c('conference-images')],1),_vm._v(" "),_c('div',{staticClass:"search-box mb-5"},[_c('search-customer-booking')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }